import { PointViewModel } from '@ng-gems/api/midback';

import { Contract } from '@models/account/contract.model';
import { DeliveryPoint } from '@models/account/delivery-point.model';
import { Commodity } from '@models/types/all';

import { ApiAdapter } from './adapter';
import { EstablishmentAdapter } from './establishment.adapter';

export class DeliveryPointAdapter extends ApiAdapter<DeliveryPoint> {
  private establishmentAdapter = new EstablishmentAdapter();

  // eslint-disable-next-line complexity
  get(json, contract?: Contract): DeliveryPoint {
    const validityStartDate = json?.['validity_start_date'] ?? json?.['validityStartDate'];
    const validityEndDate = json?.['validity_end_date'] ?? json?.['validityEndDate'];

    const deliveryPoint = new DeliveryPoint({
      // TODO #API backend should always send the same attribute for a metering point code
      meteringPoint: json?.['code'] || json?.['meter_code'] || json?.['mp_code'] || json?.['mpCode'],
      gridOperator: json?.['grid_operator_code'] || json?.['grid_operator'] || json?.['gridOperatorCode'] || json?.['gridOperator'],
      commodity: json?.['commodity'] ? json?.['commodity'].toLowerCase() : undefined,
      parentMeteringPoint: json?.['parent_code'],
      parentGridOperator: json?.['parent_grid_operator_code'],
      pointType: json?.['point_type'],
      zone: json?.['zone'],
      siteId: json?.['site_id'] || json?.['siteId'],
      siteName: json?.['siteName'],
      site: json?.['site'],
      country: json?.['country'],
      establishmentCode: json?.['establishment_code'],
      establishment: this.establishmentAdapter.get(json?.['establishment']),
      siteLabels: {
        internal: json?.['label_engie'],
        external: json?.['label_client'] || json?.['label_engie'],
      },
      validityStartDate: validityStartDate ? this.parseToBrusselsTimezone(validityStartDate) : undefined,
      validityEndDate: validityEndDate ? this.parseToBrusselsTimezone(validityEndDate) : undefined,
      msbNumber: json?.['msb_number'],
      meteringPointOperator: json?.['metering_point_operator'],
      marketArea: json?.['market_area'],
      inDelivery: json?.['in_delivery'],
      toNominate: json?.['to_nominate'],
      bcvVolumeIdentifier: json?.['bcv_volume_identifier'],
      accountId: json?.['accountId'],
      addtionalInfo: json?.['additional_info'],
    });

    // We may have contract instance when this adapter is used in cascade when scanning a contract
    if (contract) {
      deliveryPoint.contract = contract;
    } else if (json?.['contract_id'] || json?.['contractId']) {
      deliveryPoint.contract = new Contract({ id: json?.['contract_id'] || json?.['contractId'] });
    }

    return deliveryPoint;
  }
}

export class DeliveryPointModelAdapter extends ApiAdapter<DeliveryPoint> {
  get(json: PointViewModel): DeliveryPoint {
    return new DeliveryPoint({
      meteringPoint: json.mpCode,
      gridOperator: json.gridOperatorCode,
      commodity: json.commodity === 'Gas' ? Commodity.gas : Commodity.power,
    });
  }
}
